import type { HireDepartmentDetail } from "~/lib/marketplace/hire-recommendations-pricing";
import type { HireRecommendationsSelection } from "~/lib/marketplace/hire-recommendations-pricing";

export function buildDefaultHireDepartmentDetail(args: {
  name: string;
  leadTeamMemberEmail?: string;
}): HireDepartmentDetail {
  return {
    name: args.name.trim() || "General",
    leadTeamMemberEmail: args.leadTeamMemberEmail?.trim() || undefined,
    otherTeamMemberEmails: [],
  };
}

export function padHireDepartmentDetails(
  details: HireDepartmentDetail[],
  departmentCount: number,
  fallbackName = "General",
): HireDepartmentDetail[] {
  const padded = [...details];
  while (padded.length < departmentCount) {
    padded.push(
      buildDefaultHireDepartmentDetail({
        name: `Department ${padded.length + 1}`,
      }),
    );
  }
  return padded.slice(0, departmentCount);
}

/** Ensure departmentCount rows exist with lead assignment on each department. */
export function ensureHireDepartmentDetailsInSelection(
  selection: HireRecommendationsSelection,
  args: {
    leadTeamMemberEmail?: string;
  },
): HireRecommendationsSelection {
  const leadEmail = args.leadTeamMemberEmail?.trim();
  const count = Math.max(1, selection.departmentCount);
  const existing = selection.departmentDetails.slice(0, count);

  const withLead = existing.map((dept) => ({
    ...dept,
    name: dept.name?.trim() || "General",
    leadTeamMemberEmail: dept.leadTeamMemberEmail?.trim() || leadEmail || undefined,
    otherTeamMemberEmails: dept.otherTeamMemberEmails ?? [],
  }));

  const details = padHireDepartmentDetails(withLead, count).map((dept) => ({
    ...dept,
    leadTeamMemberEmail: dept.leadTeamMemberEmail?.trim() || leadEmail || undefined,
    otherTeamMemberEmails: dept.otherTeamMemberEmails ?? [],
  }));

  return {
    ...selection,
    departmentCount: count,
    departmentDetails: details,
  };
}
